<template>
  <fragment>
    <div class="__nav-spacer"></div>

    <div class="old-pt-15 old-pb-15 x">
      <div class="cart__container">
        <div
          class="cart__box cart__box--full"
          :class="{ 'cart--show': cart.item_count }"
        >
          <div class="cart__header">
            <div class="outer">
              <div class="mxa ac container">
                <div class="nav-spacer"></div>
                <h1 class="cheltenham-x ls--10 lg--fs-60 sm--fs-42 lh-10">
                  {{ shopifyData.title }}
                </h1>
              </div>
            </div>
          </div>

          <div class="outer">
            <div class="cart__inner mha mxa container">
              <form action="/cart" method="post" novalidate>
                <!-- Line Items Start -->
                <cart-line-item
                  v-for="(item, index) in sortedItems"
                  :key="item.id"
                  :item="item"
                  :index="index"
                >
                </cart-line-item>
                <!-- Line Items End -->

                <div class="x old-block old-pt-4 old-pb-4">
                  <div class="f cart__subtotal jce mb2">
                    <div style="padding-right: 15px">
                      <p class="h5-14 caps semi">
                        {{ shopifyData.subtotalText }}
                      </p>
                    </div>
                    <div>
                      <p class="h2 m0 semi ar js-subtotal">
                        {{ totalPrice }}
                      </p>
                      <p v-if="cart.total_discounts">
                        {{ shopifyData.savingsText }} {{ totalDiscount }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="x f jce">
                  <input
                    type="submit"
                    name="checkout"
                    :value="shopifyData.checkoutText"
                    class="button h-bg-gray rel bg-rust old-pt-2 old-pb-2 old-pr-2 old-pl-2 lh-10 caps fs-14 c-beige plaid-l ls--5 inline-block transition"
                  />
                </div>
              </form>
            </div>
          </div>
        </div>

        <div
          class="cart__box cart__box--empty"
          :class="{
            'cart--show': cart.item_count <= 0,
          }"
        >
          <div class="nav-spacer--mobile"></div>

          <div class="outer x">
            <div class="container--l mxa f jcc">
              <div class="ac empty__container">
                <div class="x">
                  <div class="old-block old-mb-3 ac">
                    <p v-html="shopifyData.cartEmptyCopy" class="h0 semi"></p>
                  </div>
                  <div class="old-block">
                    <a
                      :href="shopifyData.collectionUrl"
                      role="button"
                      class="button h-bg-gray rel bg-rust old-pt-2 old-pb-2 old-pr-2 old-pl-2 lh-10 caps fs-14 c-beige plaid-l ls--5 inline-block transition"
                    >
                      Shop all products
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "cart",
  computed: {
    ...mapGetters({
      totalPrice: "cart/formattedTotalPrice",
      totalDiscount: "cart/formattedTotalDiscount",
      sortedItems: "cart/sortedItems",
    }),
    ...mapState({
      items: (state) => state.cart.data,
      cart: (state) => state.cart.data,
    }),
  },
  props: {
    shopifyData: {
      title: String,
      cartEmptyCopy: String,
      collectionUrl: String,
      checkoutText: String,
      subtotalText: String,
      savingsText: String,
    },
  },
};
</script>
